


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewLstEvolucionFeedlot = () => import('./Index')
const DashboardVisualFeedlot = () => import('./Reportes/dashboard_evolucion.vue')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'lst_evolucion_feedlot',
        name: 'Evolución Feedlot',
        component: ViewLstEvolucionFeedlot,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
      {
        path: 'lst_evolucion_feedlot/dashboard_evolucion',
        name: 'DashBoard_Evolucion',
        component: DashboardVisualFeedlot,
      }
    ],
  },
]

export default router
